/**
 * Scriptures for lesson elder-1 (ministering). D&C 20 and 107 aligned with scriptures.training.core3; D&C 42, James, and Mark from churchofjesuschrist.org.
 */
import type { Scripture } from './scriptures';

export const elder1TrainingScripturesEn: Scripture[] = [
  {
    id: 'dc-20-38-45',
    reference: 'Doctrine and Covenants 20:38–45',
    text:
      'The duty of the elders, priests, teachers, deacons, and members of the church of Christ—An apostle is an elder, and it is his calling to baptize; And to ordain other elders, priests, teachers, and deacons; And to administer bread and wine—the emblems of the flesh and blood of Christ— And to confirm those who are baptized into the church, by the laying on of hands for the baptism of fire and the Holy Ghost, according to the scriptures; And to teach, expound, exhort, baptize, and watch over the church; And to confirm the church by the laying on of the hands, and the giving of the Holy Ghost; And to take the lead of all meetings. The elders are to conduct the meetings as they are led by the Holy Ghost, according to the commandments and revelations of God.',
    verses: [
      {
        verse: 38,
        text: 'The duty of the elders, priests, teachers, deacons, and members of the church of Christ—An apostle is an elder, and it is his calling to baptize;',
      },
      {
        verse: 39,
        text: 'And to ordain other elders, priests, teachers, and deacons;',
      },
      {
        verse: 40,
        text: 'And to administer bread and wine—the emblems of the flesh and blood of Christ—',
      },
      {
        verse: 41,
        text: 'And to confirm those who are baptized into the church, by the laying on of hands for the baptism of fire and the Holy Ghost, according to the scriptures;',
      },
      {
        verse: 42,
        text: 'And to teach, expound, exhort, baptize, and watch over the church;',
      },
      {
        verse: 43,
        text: 'And to confirm the church by the laying on of the hands, and the giving of the Holy Ghost;',
      },
      {
        verse: 44,
        text: 'And to take the lead of all meetings.',
      },
      {
        verse: 45,
        text: 'The elders are to conduct the meetings as they are led by the Holy Ghost, according to the commandments and revelations of God.',
      },
    ],
    context: 'Elder duties: ordinances, teaching, watching over the church, and conducting meetings.',
  },
  {
    id: 'james-5-14-15',
    reference: 'James 5:14–15',
    text:
      'Is any sick among you? let him call for the elders of the church; and let them pray over him, anointing him with oil in the name of the Lord: And the prayer of faith shall save the sick, and the Lord shall raise him up; and if he have committed sins, they shall be forgiven him.',
    verses: [
      {
        verse: 14,
        text: 'Is any sick among you? let him call for the elders of the church; and let them pray over him, anointing him with oil in the name of the Lord:',
      },
      {
        verse: 15,
        text: 'And the prayer of faith shall save the sick, and the Lord shall raise him up; and if he have committed sins, they shall be forgiven him.',
      },
    ],
    context: 'The prayer of faith, anointing with oil, and the elders of the church.',
  },
  {
    id: 'dc-42-44-45',
    reference: 'Doctrine and Covenants 42:44–45',
    text:
      'And the elders of the church, two or more, shall be called, and shall pray for and lay their hands upon them in my name; and if they die they shall die unto me, and if they live they shall live unto me. And thou shalt live together in love, insomuch that thou shalt weep for the loss of them that die, and more especially for those that have not hope of a glorious resurrection.',
    verses: [
      {
        verse: 44,
        text: 'And the elders of the church, two or more, shall be called, and shall pray for and lay their hands upon them in my name; and if they die they shall die unto me, and if they live they shall live unto me.',
      },
      {
        verse: 45,
        text: 'And thou shalt live together in love, insomuch that thou shalt weep for the loss of them that die, and more especially for those that have not hope of a glorious resurrection.',
      },
    ],
    context: 'Elders pray and lay hands on the sick; covenant people live in love and mourn with hope.',
  },
  {
    id: 'dc-107-12',
    reference: 'Doctrine and Covenants 107:12',
    text:
      'The high priest and elder are to administer in spiritual things, agreeable to the covenants and commandments of the church; and they have a right to officiate in all these offices of the church when there are no higher authorities present.',
    verses: [
      {
        verse: 12,
        text: 'The high priest and elder are to administer in spiritual things, agreeable to the covenants and commandments of the church; and they have a right to officiate in all these offices of the church when there are no higher authorities present.',
      },
    ],
    context: 'The elder administers in spiritual things according to the covenants of the church.',
  },
  {
    id: 'mark-16-18',
    reference: 'Mark 16:18',
    text:
      'They shall take up serpents; and if they drink any deadly thing, it shall not hurt them; they shall lay hands on the sick, and they shall recover.',
    verses: [
      {
        verse: 18,
        text: 'They shall take up serpents; and if they drink any deadly thing, it shall not hurt them; they shall lay hands on the sick, and they shall recover.',
      },
    ],
    context: 'Signs that follow believers, including laying hands on the sick.',
  },
];
